import React from 'react';
import {PlanogramPositionObject} from "../planogram/model";

interface PlanogramContextProps {
  positionsInSitePlan: PlanogramPositionObject[];
  setPositionsInSitePlan: React.Dispatch<React.SetStateAction<PlanogramPositionObject[]>>;
}
export const PlanogramContext = React.createContext({} as PlanogramContextProps);
